import './App.scss';
import Form from "./components/Form";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { config } from './config';
import { useEffect } from 'react';
import { Header } from './models';
import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { textSpanIsEmpty } from 'typescript';
import App2 from './App2';

function App(props) {

    const readDsgvoCookie = (name) => {

        // Split cookie string and get all individual name=value pairs in an array
        var cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i];

            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if (name == cookiePair) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    }

    var lng = "en";

    if (window.location.pathname.startsWith('/de')) {
        lng = "de";
    }
    else if (window.location.pathname.startsWith('/en')) {
        lng = "en";
    }
    else if (window.location.pathname.startsWith('/es')) {
        lng = "es";
    }

    const [language, setLanguage] = React.useState<string>(lng);
    const [labelAnfrageformular, setLabelAnfrageformular] = React.useState("TO APPLICATION REQUEST");
    const [titleSystem, setTitleSystem] = React.useState("");
    const [subTitleSystem, setSubTitleSystem] = React.useState("");
    const [header, setHeader] = React.useState<any>({});
    const [showMoreContent, setShowMoreContent] = React.useState<boolean>(false);

    const [BtnDeclineLabel, setBtnDeclineLabel] = React.useState<any>("");
    const [BtnAcceptLabel, setBtnAcceptLabel] = React.useState<any>("");
    const [visible, setVisible] = React.useState(readDsgvoCookie("__gfa=GFAUmfrageDsgvo" + lng) == null ? true : false);
    const toggleDialog = () => {
        setVisible(!visible);

        writeDsgvoCookie();
    };

    const showMoreDialog = () => {
        setShowMoreContent(!showMoreContent);
    }

    const writeDsgvoCookie = () => {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        document.cookie = '__gfa=GFAUmfrageDsgvo' + lng + ';expires=' + now.toUTCString() + ';path=/';
    }

    const changeLanguage = (lang) => {

        window.location.href = config.Host + "" + lang;

        setLanguage(lang);

    }

    useEffect(() => {
        fetch(`${config.Umfrage_URL}header`,
            {
                headers: {
                    "LANG": lng
                }
            }).then((response) => {
                var json = response.json();
                return json;
            }).then(function (resp: any) {
                const header: Header = resp;

                setHeader(header);
            });
    }, [lng]);

    useEffect(() => {
        switch (language) {
            case "de":
                setLabelAnfrageformular("ZUM ANFRAGEFORMULAR");
                setBtnAcceptLabel("Akzeptieren");
                setBtnDeclineLabel("Mehr anzeigen");
                break;
            case "en":
                setLabelAnfrageformular("TO APPLICATION REQUEST");
                setBtnAcceptLabel("Accept");
                setBtnDeclineLabel("Show more");
                break;
            case "es":
                setLabelAnfrageformular("TO SOLICITUD DE SOLICITUD");
                setBtnAcceptLabel("Aceptar");
                setBtnDeclineLabel("mostrar más");
                break;
        }
    });

    return (
        <>
            <Router>
                <Switch>
                    {/* <Redirect from="/callreport_prod/contact3.html?classid=A17D9DDE-8D12-E511-8110-C4346BACDF00&lang=de" to="/de" /> */}
                    <Route path="/callreport_prod/" render={(props) => {
                        var params = new URLSearchParams(window.location.href);
                        var to = "/"+params.get("lang");
                        return <Redirect to={to} />
                    }}>

                    </Route>
                    <Route path="/">
                        <App2 />
                    </Route>
                </Switch>
            </Router>
        </>
    );
}

export default App;
